










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import ActionListSettingsForm from '@/components/action_list/ActionListSettingsForm.vue';

@Component({
  components: {
    Header,
    ActionListSettingsForm,
    Footer,
  },
})
export default class ActionListSettings extends Vue {}
